// ─── El cupo de una sección: UNA regla para el servidor y el web ────────────
// Un cupo menor o igual a 0, o ausente, significa SIN LÍMITE (sin cupo
// definido): p. ej. las secciones importadas de un sistema que no registraba
// cupos. Antes, `hasAvailableSpot` comparaba `actual < cupo` y un cupo 0
// dejaba la sección llena para siempre: reabrirla e inscribir fallaba con
// «Section is full or not open».
//
// Desde H7 (2026-10-16) crear o editar una sección con cupo 0 es la forma de
// decir «sin límite»; solo un cupo negativo se rechaza.
//
// Todo indicador de «lleno» o de cupos restantes sale de aquí: el caso de uso
// de inscripción, la admisión, el portal del alumno y las pantallas del SIS.
/** El cupo, si hay uno de verdad; `null` = sin límite. */
export function sectionCapacity(maxEnrollment) {
    return typeof maxEnrollment === 'number' && Number.isFinite(maxEnrollment) && maxEnrollment > 0
        ? maxEnrollment
        : null;
}
/** ¿Queda lugar? Sin cupo definido, siempre. (El ESTADO de la sección lo mira
 *  `Section.hasAvailableSpot`, no esta función.) */
export function sectionHasSeat(currentEnrollment, maxEnrollment) {
    const capacity = sectionCapacity(maxEnrollment);
    return capacity === null || currentEnrollment < capacity;
}
/** Cupos restantes; `null` = sin límite. Nunca negativo. */
export function sectionSeatsLeft(currentEnrollment, maxEnrollment) {
    const capacity = sectionCapacity(maxEnrollment);
    return capacity === null ? null : Math.max(0, capacity - currentEnrollment);
}
/** El cupo TOTAL de varias secciones; `null` = sin límite. Si UNA sola no
 *  tiene límite, el total tampoco: sumar solo las que tienen cupo y dividir
 *  por eso a los inscritos de todas mostraba «35/20» y una barra llena. */
export function sectionsTotalCapacity(maxEnrollments) {
    let total = 0;
    for (const m of maxEnrollments) {
        const capacity = sectionCapacity(m);
        if (capacity === null)
            return null;
        total += capacity;
    }
    return maxEnrollments.length > 0 ? total : null;
}
//# sourceMappingURL=section-capacity.js.map